module.exports = __webpack_public_path__ + "img/ico-registration-blue.a2a48f63.svg";